import React from 'react';
import styled from 'styled-components';
import DomainIcon from '../domain/DomainIcon';
import { AutoTooltip } from '../entity/shared/components/common/AutoTooltip';

const DomainContainerWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    min-width: 0;
`;

const DomainContentWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-width: 0;

    svg {
        margin-right: 6px;
        flex-shrink: 0;
    }
`;

type Props = {
    name: string;
};

export const DomainLabel = ({ name }: Props) => {
    return (
        <DomainContainerWrapper>
            <DomainContentWrapper>
                <DomainIcon ariaLabel={name} />
                <AutoTooltip showTitle className="f-text-content">
                    {name}
                </AutoTooltip>
            </DomainContentWrapper>
        </DomainContainerWrapper>
    );
};
